// extracted by mini-css-extract-plugin
export default {"align":"PersonalInfo_align__cm3ay","title":"PersonalInfo_title__n7kAP","value":"PersonalInfo_value__S-4ID"};